import { addDays, type IsoDate, isIsoDate, monthEndOf } from "@/lib/time/dates";

/** A page month in the URL: "2026-10" (modules.md caveat 7: URL state, not UserExtend). */
const MONTH_PARAM = /^\d{4}-\d{2}$/;

export function isMonthParam(value: string): boolean {
  return MONTH_PARAM.test(value) && isIsoDate(`${value}-01`);
}

/** Callers check `isMonthParam` first; an invalid month param throws. */
export function monthFromParam(value: string): IsoDate {
  if (!isMonthParam(value)) throw new RangeError(`not a month param: ${value}`);
  return `${value}-01`;
}

export function monthParam(date: IsoDate): string {
  return date.slice(0, 7);
}

/** The first day of the month `n` months after (or before) `monthStart`. */
export function addMonths(monthStart: IsoDate, n: number): IsoDate {
  if (!Number.isInteger(n))
    throw new RangeError(`addMonths needs a whole number of months, got ${n}`);
  let cursor = `${monthStart.slice(0, 7)}-01`;
  const step = n >= 0 ? 1 : -1;
  for (let i = 0; i !== n; i += step) {
    cursor = step > 0 ? addDays(monthEndOf(cursor), 1) : `${addDays(cursor, -1).slice(0, 7)}-01`;
  }
  return cursor;
}
